@import url('../../../../node_modules/@splidejs/splide/dist/css/splide-core.min.css');

:host {
  --video-title-position: 0;
  @include reset-host;

  height: 100%;
}

$arrows-negative-margin: rem(50);
$pagination-height: rem(22);
$pagination-gap: rem(8);

:host .video-modal-slider {
  position: relative;

  height: 100%;

  .pagination-wrapper {
    position: absolute;
    top: rem(100);
    right: $gutter-mobile;

    @include mq('max', 'sm') {
      top: 50%;

      transform: translateY(-50%);
    }
  }

  .video-title {
    position: absolute;
    right: rem(9);

    min-width: rem(220);

    color: $white;
    font-weight: $fw-bold;
    line-height: 1.3;
    text-align: right;

    transform: translateX(-3px) scale(1);
    transform-origin: center right;

    transition: $transition-smooth;
    transition-property: opacity, transform;

    pointer-events: none;

    @include mq('max', 'sm') {
      top: calc(
        (#{$pagination-height} + #{$pagination-gap} + #{rem(3)}) * var(--video-title-position)
      );
      right: rem(7);
    }

    /* stylelint-disable-next-line selector-max-compound-selectors */
    &.is-hidden {
      transform: translateX(0) scale(0.95);
      opacity: 0;
    }
  }

  .splide {
    &__track,
    &__list {
      height: 100%;
    }

    &__track {
      overflow: hidden;

      border-radius: $radius-md;

      @include mq('max', 'md') {
        border-radius: 0;
      }
    }

    &__slide {
      overflow: hidden;
    }

    &__arrows {
      position: absolute;
      top: 50%;
      left: -$arrows-negative-margin;
      z-index: 1;

      display: flex;
      justify-content: space-between;
      width: calc(100% + ($arrows-negative-margin * 2));

      pointer-events: none;
    }

    &__arrow {
      display: flex;
      align-items: center;
      justify-content: center;

      width: rem(40);
      height: rem(40);

      color: $white;

      background: transparent;
      border: 2px solid $white;
      border-radius: 50%;
      box-shadow: 0 0 0 0 $white;

      cursor: pointer;
      cursor: pointer;

      transition: $transition-smooth;
      transition-property: opacity, box-shadow;

      pointer-events: visible;

      &:hover {
        box-shadow: 0 0 0 2px $white;
      }

      &:disabled {
        opacity: 0;

        pointer-events: none;
      }

      &:focus-visible {
        outline: 1px solid $white;
        outline-offset: 3px;
      }
    }

    &__pagination {
      display: flex;
      gap: $pagination-gap;
      align-items: center;

      &--ttb {
        flex-direction: column;
      }
    }

    &__pagination__page {
      width: 3px;
      height: $pagination-height;

      line-height: unset;

      border-width: 0;
      border-radius: 2px;

      opacity: 0.5;

      &.is-active {
        opacity: 1;
      }
    }

    /* stylelint-disable-next-line selector-max-compound-selectors */
    &__arrow--prev svg {
      transform: scaleX(-100%);
    }
  }
}
